import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';
import ComboUnidadNegocio from "../componentes/ComboUnidadNegocio";


const useStyles = makeStyles((theme) => ({
    gerencia: {display: 'inline-block', width: 200, marginLeft: 8},
    gerencia_d: {display: 'inline-block', width: 400, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_gerencia = values.gerencia

    if (w_gerencia===undefined) {
        errors.gerencia = ['El campo Código es requerido'];
    }else {
        if (w_gerencia === null) {
            errors.gerencia = ['El campo Código es requerido'];
        } else {
            w_gerencia = w_gerencia.trim()
            if (w_gerencia === '') {
                errors.gerencia = ['El campo Código es requerido'];
            }
        }
    }


    var w_gerencia_d = values.gerencia_d

    if (w_gerencia_d===undefined) {
        errors.gerencia_d = ['El campo Descripcion es requerido'];
    }else {
        if (w_gerencia_d === null) {
            errors.gerencia_d = ['El campo Descripcion es requerido'];
        } else {
            w_gerencia_d = w_gerencia_d.trim()
            if (w_gerencia_d === '') {
                errors.gerencia_d = ['El campo Descripcion es requerido'];
            }
        }
    }


    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/UnidadGerencia`;

const UnidadGerenciaCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Unidad Gerencia</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS UNIDAD GERENCIA">

                    <ComboUnidadNegocio readOnly={false}/>

                    <TextInput
                        label="Código Unidad Gerencia"
                        source="gerencia"
                        formClassName={classes.gerencia}
                        placeholder="Ingrese Código Unidad Gerencia"
                        helperText="Código"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                    <br/>

                    <TextInput
                        id="standard-full-width"
                        label="Descripción Unidad Gerencia"
                        source="gerencia_d"
                        formClassName={classes.gerencia_d}
                        multiline
                        placeholder="Ingrese Descripcion Unidad Gerencia"
                        helperText="Descripcion"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>

                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default UnidadGerenciaCreate;


